<div class="board-group-header">
  @if ($titleField(); as titleField) {
    <span class="board-group-header-title">
      <wb-value [field]="titleField" [value]="$titleValue()" [data]="$record()" [truncate]="true" [plain]="true" />
    </span>
  } @else {
    <span class="board-group-header-title">{{ $groupName() }}</span>
  }
  @if ($showCount()) {
    <span class="board-group-header-meta">{{ $countLabel() }}</span>
  }
  @for (field of $elevatedFields(); track field.path ?? field.name; let first = $first) {
    <span class="board-group-header-sep" aria-hidden="true">·</span>
    <span class="board-group-header-field" [class.is-primary]="first">
      <wb-value [field]="field" [data]="$record()" [truncate]="true" [compact]="true" [plain]="true" [addressLayout]="'inline'" />
    </span>
  }
</div>
